import React, { FC, ForwardedRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

const MfButton: FC<ButtonProps> = React.forwardRef(
  (props: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => (
    <Button {...props} ref={ref} />
  )
);

export default MfButton;
